import { Observable } from 'rxjs';
import { EquipmentModel } from '../models/complex/equipment.model';
import { TableModel } from '../models/complex/table.model';
import { SoftwareLicenceModel } from '../services/software-licences/software-licence.model';
import { InjectionToken } from '@angular/core';

export interface SoftwareLicencesInterface {
    getTableModelForSoftwareLicences(mainEquipment: EquipmentModel): Observable<TableModel<SoftwareLicenceModel>>;
    getSoftwareLicencesForEquipment(equipment: EquipmentModel): Observable<SoftwareLicenceModel[]>;
}

export const SoftwareLicencesInstanceToken = new InjectionToken<SoftwareLicencesInterface>('SoftwareLicencesInterface');
